import ActionTypes from '../Actions/ActionTypes';

let initialState = {
    payments: [],
    paymentsPagination: null,
};

const PaymentsReducer = (state = initialState, action) => {
    switch (action.type) {

        case ActionTypes.GET_PAYMENTS:
            state = {
                ...state,
                payments: action.payload?.data,
                paymentsPagination: action.payload,
            };
            break;

        case ActionTypes.CLEAR_PAYMENTS:
            state = {
                ...state,
                payments: [],
                paymentsPagination: null,
            };
            break;


        default:
            break;
    }
    return state;
};

export default PaymentsReducer;
